function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1D998C",
  d: "M.672.652v41.836h9.183v14.184l20-14.184h1.43v11.223l22.961.004 21.938 11.633V53.715h7.145V10.86H57.817V.657L.672.652zm27.96 37.754l-14.694 10.41v-10.41H4.754V4.734h48.98v33.672H28.633zm50.614-23.469v34.695H72.1v8.879l-16.836-8.879H35.367v-7.145h22.45v-27.55h21.429z"
});

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 66,
    viewBox: "0 0 84 66"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/chat.2730dc25.svg";
export { SvgChat as ReactComponent };